import React from 'react';
import t from 'prop-types';
import classNames from 'classnames';
import { Icon } from '../Icon';

const ToastBodyContent = ({ children }) => (
  <div className="toast-content">{children}</div>
);

export const Toast = ({
  className,
  color,
  icon,
  title,
  show,
  toggle,
  autoHide,
  duration,
  children,
}) => (
  <div
    className={classNames('toast', className, {
      show,
      [`toast-${color}`]: color,
    })}
    role="alert"
    aria-live="polite"
    aria-atomic="true"
  >
    {icon &&
      (typeof icon === 'string' ? (
        <Icon name={icon} />
      ) : (
        <div className="toast-icon">{icon}</div>
      ))}
    <div className="toast-body">
      {title && <div className="toast-title">{title}</div>}
      {children && <ToastBodyContent>{children}</ToastBodyContent>}
    </div>
    {typeof toggle === 'function' && (
      <button
        type="button"
        className={classNames('btn-close btn-sm bg-hover-white', {
          [`btn-close-${color}`]: color,
        })}
        onClick={toggle}
        aria-label="Dismiss"
        title="Dismiss"
      />
    )}
    {autoHide && typeof toggle === 'function' && (
      <div
        className="toast-progress"
        onAnimationEnd={toggle}
        style={duration ? { animationDuration: `${duration}ms` } : {}}
      />
    )}
  </div>
);

Toast.propTypes = {
  /** Theme color of the toast. */
  color: t.oneOf(['success', 'danger', 'warning']),
  /** Additional classNames to add to the toast element. */
  className: t.string,
  /** Name of icon or JSX content to render in the top left corner. */
  icon: t.node,
  /** Title or short message to show in the toast. */
  title: t.string,
  /**
   * Flag that determines if the show class is added, which is used for
   * animating the toast when in a toast container.
   */
  show: t.bool,
  /** Function to close the toast. */
  toggle: t.func.isRequired,
  /** Flag that determines if the toast gets automatically hidden. */
  autoHide: t.bool,
  /**
   * Number of milliseconds that the toast should remain visible if autoHide is
   * true. Minimum is 4000.
   */
  duration: t.number,
  /** JSX content to render in the body of the toast. */
  children: t.node,
};
